import * as React from "react"

import Layout from "../../components/layout"
import Menuicons from "../../components/menuicons"
import Banner_afiliate from "../../components/banner_afiliate"
import Slidernoticias from "../../components/slidernoticias"
import Carousel from "../../components/carousel"
import Seo from "../../components/seo"
import Sliderblog from "../../components/sliderblog"
import Slider from "../../components/slider"

const IndexPage = () => (
  <>
    <Layout site="proveedores" page="/" className="mitexto">
      <Seo title="Proveedores" />
      <Carousel
        site="proveedores"
        style={{ margin: 0, display: "block" }}
      ></Carousel>
      <Slider site="proveedores" />
      <div className="bg-default text-gray-600 work-sans leading-normal text-base tracking-normal">
        <section className="bg-white py-2 mitexto">
          <Banner_afiliate site="personas" />
          <Menuicons site="proveedores" />
          <Slidernoticias site="proveedores" />
        </section>
        <section
          className="bg-white tamano_imagen_blog mitexto"
          style={{ height: "23rem" }}
        >
          <a href={"/blogs"}>
            <Sliderblog />
          </a>
        </section>
      </div>
    </Layout>
  </>
)
export default IndexPage
